/* eslint-disable */
import { useContext, useEffect, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Paper, Select, Button } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import DateFilter from '../InvestigationPage/DateFilter'
import DateRangePicker from '../../components/DateRangePicker'
import { OrgAppContext } from '../../OrgAppContext'
import AddIcon from '@mui/icons-material/Add'
import '../../globalStyle.scss'
import BreachDataList from './BreachDataList'
import CreateBreachDialog from './CreateBreachDialog'
import { useApiGet } from '../../apiCalls/useApi'
import { getBreachList } from '../../apiCalls/breachApi'

export default function BreachManagement() {
  const {appId} = useContext(OrgAppContext)

  const defaultEndDate = dayjs().endOf('day').toDate()

  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [data, setData] = useState<any>({
    data: [],
    pageInfo: {},
  })

  const [severityFilter, setSeverityFilter] = useState<string>('ALL')
  const [statusFilter, setStatusFilter] = useState<string>('ALL')

  const [listFromDate, setListFromDate] = useState<Date | null>(
    dayjs().subtract(3, 'months').startOf('day').toDate()
  )
  const [listToDate, setListToDate] = useState<Date | null>(dayjs().endOf('day').toDate())
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false)

  const [openCreateBreachDialog, setOpenCreateBreachDialog] = useState<boolean>(false)
  const [updateFlag, setUpdateFlag] = useState<number>(0)



  const fetchBreachDataList = useApiGet(getBreachList)

  const breachList = data.data
    ? {
        ...data,
        data: data.data
          .filter((item: any) => statusFilter === 'ALL' || item.status === statusFilter)
          .filter((item: any) => severityFilter === 'ALL' || item.severity === severityFilter)
          .map((e: any) => ({
            ...e,
            severity: e.severity ? t('severityLevels.' + e.severity) : '',
            status: e.status ? t('breachStatus.' + e.status) : '',
          })),
      }
    : []

  const handleSeverityChange = (event: { target: { value: string } }) => {
    setSeverityFilter(event.target.value)
  }

  const handleStatusChange = (event: { target: { value: string } }) => {
    setStatusFilter(event.target.value)
  }

  function handleDateSubmitForList() {
    if (
      listFromDate &&
      dayjs(listFromDate).isValid() &&
      listToDate &&
      dayjs(listToDate).isValid()
    ) {
      const fromDateTimestamp = dayjs(listFromDate).valueOf()
      const toDateTimestamp = dayjs(listToDate).valueOf()
      if (fromDateTimestamp > toDateTimestamp) {
        return
      }
      setIsLoading(true)
      fetchBreachDataList({
        startDate: dayjs(listFromDate).format('YYYY-MM-DD'),
        endDate: dayjs(listToDate).format('YYYY-MM-DD'),
      }).then((res) => {
        if (!res || !res.data || res.error) return
        setData({
          data: res.data,
          pageInfo: {},
        })
        setIsLoading(false)
      })
    }
  }

  useEffect(() => {

    if (!appId) {
      return
    }
    setIsLoading(true)
    fetchBreachDataList({
      startDate: dayjs(listFromDate).format('YYYY-MM-DD'),
      endDate: dayjs(listToDate).format('YYYY-MM-DD'),
    }).then((res) => {
      if (!res || !res.data || res.error) return
      setData({
        data: res.data,
        pageInfo: {},
      })
      setIsLoading(false)

    })

  }, [appId, updateFlag])

  return (
    <Paper elevation={0} className='paperStyle'>
      <div style={{ height: 'calc(100% - 84px)' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DateFilter
              setStartDate={setListFromDate}
              setEndDate={setListToDate}
              defaultEndDate={defaultEndDate}
              submit={handleDateSubmitForList}
              setIsCustomDate={setIsCustomDate}
              setIsLoading={setIsLoading}
              isCustomDate={isCustomDate}
            />
            {isCustomDate && (
              <DateRangePicker
                fromDate={listFromDate}
                setFromDate={setListFromDate}
                toDate={listToDate}
                setToDate={setListToDate}
                submit={handleDateSubmitForList}
              />
            )}
          </div>
          <Button
            variant='contained'
            startIcon={<AddIcon />}
            onClick={() => {
              setOpenCreateBreachDialog(true)
            }}
            style={{ height: '36px' }}
          >
            Add Breach
          </Button>

          <CreateBreachDialog
            open={openCreateBreachDialog}
            onClose={() => setOpenCreateBreachDialog(false)}
            setUpdateFlag={setUpdateFlag}
          />
        </div>
        <div style={{ marginTop: '8px' }}>
          <FormControl>
            <InputLabel>Severity</InputLabel>
            <Select
              classes={{ select: 'longSelect' }}
              value={severityFilter}
              label='Severity'
              onChange={handleSeverityChange}
              sx={{ height: '36px' }}
            >
              <MenuItem value={'ALL'}>{t('ALL')}</MenuItem>
              <MenuItem value={'HIGH'}>{t('severityLevels.HIGH')}</MenuItem>
              <MenuItem value={'MEDIUM'}>{t('severityLevels.MEDIUM')}</MenuItem>
              <MenuItem value={'LOW'}>{t('severityLevels.LOW')}</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ marginLeft: '6px' }}>
            <InputLabel>Status</InputLabel>
            <Select
              classes={{ select: 'longSelect' }}
              value={statusFilter}
              label='Status'
              onChange={handleStatusChange}
              sx={{ height: '36px' }}
            >
              <MenuItem value={'ALL'}>All</MenuItem>
              <MenuItem value={'OPEN'}>Open</MenuItem>
              <MenuItem value={'CLOSED'}>Closed</MenuItem>
            </Select>
          </FormControl>
        </div>

        <BreachDataList
          appId={appId}
          data={breachList}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
    </Paper>
  )
}
